export const messageConstants = {
    LOADING:"LOADING",
    RESPONSE:"RESPONSE",
    GET_MESSAGES:"GET_MESSAGES",
    LOAN_OFFICERS_UNREAD:"LOAN_OFFICERS_UNREAD",
    MART_OFFICERS_UNREAD:"MART_OFFICERS_UNREAD",
    GET_MESSAGE_DETAILED:"GET_MESSAGE_DETAILED",
    GET_CONVERSATIONS:"GET_CONVERSATIONS",
    GET_USERS_FOR_CHAT:"GET_USERS_FOR_CHAT",
}